export default [
  {
    label: 'Service Agreement Maintenance',
    value: 'ServiceAgreementDetail',
  },
];
